import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useGoBack from '@/hooks/useGoBack';
// import useGoBack from '@/hooks/useGoBack';
import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import GalleryService from '@/services/gallery.service';
// import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';

import './styles/SaveAsDraftDialog.css';

// mode: 'article' or 'post'
export default function SaveAsDraftDialog({
  formState,
  open,
  close,
  mode = 'article' // Default mode is 'article'
}) {
  const t = useTranslations('common.forms.board_editor');
  const { cacheHandler } = useStateHandler();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function discardChanges() {
    close();       // close the dialog
    navigate(-1);  // leave the editor without saving
  }

  const goBackHandler = useGoBack(
    `/profile/board?view=${mode==="post" ? 'posts' : 'articles'}`
  );

  function goToDraftEditor() {
    goBackHandler(); // go back to the board
    // navigate to the draft editor with the draft data
  }

  async function saveDraft() {
    setLoading(true);

    if (Utils.isPostMediaUploading(formState)) {
      alert(t('wait_for_uploads'));
      setLoading(false);
    } else if (mode === 'article' && !formState.post_title) {
      // only articles require a title
      alert(t('article_title_required'));
      setLoading(false);
    } else {
      /* -----------------------------------------------------------
         LOG what we’re about to send – confirms post_texts exists
      ------------------------------------------------------------ */
      const payload  = structuredClone(formState);
      const { response, data } = await GalleryService.submitPost(payload);

      if (response.ok) {
        cacheHandler.triggerAction("POST_DRAFT_SAVED");
        const cleaned = {
          ...data,
          post_container: {
            ...data.post_container,
            post_polls: (data.post_container.post_polls  || []).map(p => ({ ...p, published: false })),
            post_quizzes: (data.post_container.post_quizzes|| []).map(q => ({ ...q, published: false }))
          }
        };
        goToDraftEditor(cleaned);
      }
    }
  }

  return (
    <GenericPopup
      className="save-as-draft-popup"
      open={open}
      opacity
      onCloseAction={discardChanges}
      closeButtonText={(
        <>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--desktop">
            {t('discard_changes')}
          </span>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--mobile">
            {t('discard')}
          </span>
        </>
      )}
      onConfirm={saveDraft}
      confirmButtonText={(
        <>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--desktop">
            {t('save_as_draft')}
          </span>
          <span className="save-as-draft-popup__btn-label save-as-draft-popup__btn-label--mobile">
            {t('save')}
          </span>
        </>
      )}
    >
      <div className="artwork-confirmation-dialog-popup__header">
        <Text className="confirmation-dialog-popup__header-text">
          {t('save_as_draft_question')}
        </Text>
        <XIcon
          className="artwork-confirmation-dialog-popup__close"
          onClick={close}
        />
      </div>

      {/* body */}
      <Text
        className="confirmation-dialog-popup__text"
        paragraph
      >
        {t('leave_without_saving')}
      </Text>
    </GenericPopup>
  );
}
